<template>
    <div class="box-card el-card">
        <div class="el-card__header qwe-card__header">{{ title }}</div>
        <div class="el-card__body qwe-card__body">
            <div v-if="localList.length == 0">
                <el-empty class="localStorge-empty" :image-size="80" description="当前未保存任何数据" />
            </div> 
            <div v-else>
                <div class="pointer list-item" v-for="(item,index) in localList"
                    :key="index"
                    @click="select(item.value)">
                    <el-icon class=""><document /></el-icon>
                    <span >{{ item.name }}</span>
                    <span class="deleteIcon">
                        <el-popconfirm title="是否删除当前查询？" confirmButtonText="确认" cancelButtonText="取消" @confirm="deleteItem(index)">
                            <template #reference>
                                <el-icon><circleClose /></el-icon>
                            </template>
                        </el-popconfirm>
                    </span> 
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .localStorge-empty{
        padding: 5px 0 !important;
    }

    .list-item:hover{
        background-color:  var(--el-color-primary-light-9);
    }

    .list-item:active{
        background-color:  var(--el-color-primary-light-9);
    }

    .list-item{
        line-height: 18px;
        padding: 4px 10px;
        display: flex;
        align-items: center;
    }

    .list-item .deleteIcon{
        display: none;
        margin-left: auto;
    }

    .list-item:hover>.deleteIcon{
        display: block;
    }

    .qwe-card__header{
        padding: 8px 16px !important;
    }

    .qwe-card__body{
        padding: 10px 0 !important;
    }
</style>

<script>
    import { qweIsEmpty } from '../../common/commonHelper';
    import { Document, CircleClose } from '@element-plus/icons-vue';

    export default {
        name:'localStorgeSave',
        props:{
            title:{
                type:String
            },
            localStorageKey:{
                type:String
            }
        },
        emits:[
            "selectValue"
        ],

        components:{
            'document':Document,
            'circleClose':CircleClose
        },

        data:function(){
            return {
                localList:[]
            }
        },
        created:function(){
            let StorageDataString = localStorage.getItem(this.localStorageKey);
            if(!qweIsEmpty(StorageDataString)){
                let StorageData = JSON.parse(StorageDataString);
                this.localList = StorageData;
            }
        },
        methods:{
            addItem:function(name,value){
                this.localList.push({name:name,value:value});
                this.save();
            },
            deleteItem:function(index){
                this.localList.splice(index,1);
                this.save();
            },
            save:function(){
                localStorage.setItem(this.localStorageKey,JSON.stringify(this.localList));
            },
            select:function(value){
                this.$emit("selectValue",value);
            }
        }
    }

</script>